"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Truncate", {
  enumerable: true,
  get: function () {
    return _Truncate.Truncate;
  }
});
var _Truncate = require("./Truncate");